import { useEffect, useState } from "react";

const useCurrentLocation = () => {
	const [position, setPosition] = useState({
		latitude: 54.509865,
		longitude: -2.118092,
		changed: false,
	});
	useEffect(() => {
		navigator.geolocation.getCurrentPosition(
			(pos) => {
				setPosition({
					latitude: pos.coords.latitude,
					longitude: pos.coords.longitude,
					changed: true,
				});
			},
			(err) => console.log(err),
			{ enableHighAccuracy: true }
		);
	}, []);
	return position;
};

export default useCurrentLocation;
